import _ from 'lodash';
import React from 'react';

import NumericInput from 'components/NumericInput';
import { FontSizeLimit } from 'const';
import { useFontSize } from './hooks';
import { FontSizeProps } from './models';
import styles from './styles.module.scss';

const EMPTY_VALUE = '-';

const FontSize: React.FunctionComponent<FontSizeProps> = (props) => {
  const { container, fontSize, toggleFontSize, manual, toggleManual, dataTestId = 'fontSize' } = useFontSize(props);

  const [fontSizeState, setFontSize] = React.useState(fontSize);
  const applyFontSize = (): void => {
    const newValue = _.clamp(fontSizeState, FontSizeLimit.MIN, FontSizeLimit.MAX);
    setFontSize(newValue);
    toggleFontSize(newValue);
    toggleManual();
  };

  const onChangeSize = (value: number): void => {
    const newValue = _.clamp(value, FontSizeLimit.MIN, FontSizeLimit.MAX);
    setFontSize(newValue);
    toggleFontSize(newValue);
  };

  React.useEffect(
    () => {
      setFontSize(fontSize);
    },
    [fontSize],
  );

  return (
    <div className={styles.FontSize} ref={container} data-testid={dataTestId}>
      {
        manual
          ?
          <NumericInput
            className={styles.input}
            autoFocus={true}
            value={fontSizeState}
            onChange={setFontSize}
            onEnterPress={applyFontSize}
            showButtonControls={false}
            maxLength={2}
            onChangeSize={onChangeSize}
            addEvent={true}
            dataTestId={`${dataTestId}-numericInput0`}
          />
          : <span className={styles.text} onDoubleClick={toggleManual}>{fontSize || EMPTY_VALUE}</span>
      }
    </div>
  );
};

export default FontSize;
